<template>
  <div class="pb">
    <img :src="logo" :alt="alt" class="pb-logo" @error="masquer" />
    <span v-if="note" class="pb-note">{{ note }}</span>
  </div>
</template>

<script setup>
/**
 * LA BARRE DE MARQUE D'UN ÉCRAN PUBLIC.
 *
 * Un visiteur qui ouvre un lien reçu par e-mail se demande d'abord chez qui il
 * est tombé. La barre répond en haut de page, une fois, et se tait ensuite :
 * fond blanc, logo à hauteur lisible, filet de l'accent sous elle. C'est tout
 * ce dont la marque a besoin sur un écran dont le sujet est ailleurs.
 *
 * ELLE REMPLACE LE BANDEAU DE COULEUR PLEINE HAUTEUR. Le grand aplat qui
 * portait logo, titre et trois paragraphes poussait le premier champ sous la
 * ligne de flottaison et forçait un texte clair sur fond saturé. Le titre
 * appartient à la page (`PublicHeader`), pas à la marque.
 *
 * LE FILET EST DANS LE COMPOSANT, pas dans la vue : c'est lui qui porte
 * l'accent, et il doit rester collé sous la barre quel que soit le cadre.
 *
 * Un logo qui ne charge pas s'efface (le lien peut être ouvert hors ligne, ou
 * le fichier avoir bougé) : mieux vaut une barre vide qu'une icône cassée.
 */
defineProps({
  /** Chemin du logo, servi depuis `public/`. */
  logo: { type: String, required: true },
  /** Nom de la marque, lu par les lecteurs d'écran. */
  alt: { type: String, required: true },
  /** Mention discrète à droite : ce que cette page est, en trois mots. */
  note: { type: String, default: null }
})

function masquer(evenement) {
  evenement.target.style.display = 'none'
}
</script>

<style scoped>
.pb {
  display: flex;
  align-items: center;
  gap: var(--spacing-3);
  min-height: 72px;
  padding: var(--spacing-2) var(--spacing-6);
  background: var(--color-bg-primary);
  border-bottom: 3px solid var(--color-primary);
}

.pb-logo {
  display: block;
  height: 40px;
  width: auto;
}

.pb-note {
  margin-left: auto;
  font-size: var(--font-size-sm);
  color: var(--color-text-tertiary);
}

@media (max-width: 768px) {
  .pb {
    min-height: 64px;
    padding: var(--spacing-2) var(--spacing-4);
  }

  .pb-logo {
    height: 34px;
  }

  /* La mention passe après le logo : à cette largeur, elle ferait retomber le
     logo sur une deuxième ligne. */
  .pb-note {
    display: none;
  }
}
</style>
